import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from './index';

/**
 * A wrapper component that checks if the user is authenticated
 * and redirects to the login page if not
 */
export const RequireAuth = ({ children }) => {
  const { isAuthenticated, accessToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // If not authenticated, redirect to login
    if (!isAuthenticated) {
      // Save the current path to redirect back after login
      const redirectPath = location.pathname;
      localStorage.setItem('afterLoginRedirect', redirectPath);
      navigate('/auth');
    }
  }, [isAuthenticated, accessToken, navigate, location]);
  
  // If authenticated, render the children components
  return isAuthenticated ? children : (
    <div className="auth-required-container">
      <h2>Authentication Required</h2>
      <p>Loading...</p>
    </div>
  );
};

export default RequireAuth; 